export default __webpack_public_path__ + "_/images/b-day/bg-4b79171d6aee671f36611f6c59b4a44338d7a34b290abcd728b13c64fe3306cb.svg";